module.exports = __webpack_public_path__ + "img/boostrap.7321a5c4.png";